import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { generateTestId } from '../../../util/TestUtil';
import WarrantyBadge10 from './assets/WarrantyBadge10';
import WarrantyBadge20 from './assets/WarrantyBadge20';
import WarrantyBadge25 from './assets/WarrantyBadge25';
import WarrantyBadge3 from './assets/WarrantyBadge3';
import WarrantyBadge30 from './assets/WarrantyBadge30';
import WarrantyBadge5 from './assets/WarrantyBadge5';
import WarrantyBadge7 from './assets/WarrantyBadge7';
import { WarrantyDetails } from './WarrantyDetails';
const WARRANTY_LABEL_TEST_ID = 'warranty-label';
const WARRANTY_BADGES = {
    3: WarrantyBadge3,
    5: WarrantyBadge5,
    7: WarrantyBadge7,
    10: WarrantyBadge10,
    20: WarrantyBadge20,
    25: WarrantyBadge25,
    30: WarrantyBadge30,
};
/**
 * Displays a warranty section with a GARAN badge SVG matching the warranty duration and a 'read more' link.
 * Add a new entry to WARRANTY_BADGES when a new warranty period SVG is provided by the design team.
 * Used inside PDP tab containers when the AEM `showWarrantyInTab` toggle is enabled.
 */
export const WarrantyLabel = ({ warrantyYears, brand = '', productCode = '', onReadMoreClick, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const Badge = WARRANTY_BADGES[warrantyYears];
    if (!Badge) {
        return null;
    }
    return (_jsxs(Stack, { direction: "col", gap: "2", testId: WARRANTY_LABEL_TEST_ID, children: [_jsx(TextAlpha, { variant: "subheadingS", color: "emphasised", as: "h2", testId: generateTestId({ testId: WARRANTY_LABEL_TEST_ID, suffix: 'title' }), children: t('pdp.warranty.title') }), _jsx(Box, { backgroundColor: "quiet-3", borderRadius: "md", padding: "4", testId: generateTestId({ testId: WARRANTY_LABEL_TEST_ID, suffix: 'badge' }), children: _jsxs(Stack, { direction: "col", gap: "3", wrap: "nowrap", align: "start", children: [_jsx(Badge, { ariaLabel: t('pdp.warranty.badge.aria', { years: warrantyYears }) }), _jsx(WarrantyDetails, { brand: brand, productCode: productCode, warrantyYears: warrantyYears, onReadMoreClick: onReadMoreClick })] }) })] }));
};
